import * as Sentry from '@sentry/browser';

import vars from '../../../../vars.js';

function init() {
  //eslint-disable-next-line
  if (process.env.APP_ENV === 'production') {
    if (vars.slug == null) {
      console.warn('Sentry cannot be initialised if slug is absent from vars.js');
      return;
    }

    Sentry.init({
      dsn: 'https://5ad6b69f85d7414e93cdee78a8f42590@o52731.ingest.sentry.io/5457199',
      release: `Client Website: ${vars.slug}`,
    });
  }
}

export default {
  init,
};


// WEBPACK FOOTER //
// ./src/static/js/modules/sentry.js